import React from "react";
import { Link } from "react-router-dom";
import PolicyLayout, { PolicySection } from "./PolicyLayout";

function Returns() {
  return (
    <PolicyLayout
      title="Returns & Refunds Policy"
      intro="We want return terms to be clear before you buy. This policy covers change-of-mind returns and is separate from the remedies available for faulty, damaged, or incorrectly supplied goods."
      contactSubject="a return, exchange, or refund"
    >
      <PolicySection title="1. Change-of-mind return window">
        <p>
          Contact us within 14 calendar days after delivery to request a
          change-of-mind return. Wait for return instructions before sending the
          item. This voluntary window does not shorten any longer cancellation or
          return right that must apply under the law where you live.
        </p>
      </PolicySection>

      <PolicySection title="2. Return condition">
        <p>A change-of-mind item must be:</p>
        <ul>
          <li>unworn, unused, unaltered, and in resalable condition;</li>
          <li>free from scratches, scents, cosmetics, and other signs of wear;</li>
          <li>returned with its original tags, protective materials, components, and packaging; and</li>
          <li>accompanied by proof of purchase and the authorised return details.</li>
        </ul>
        <p>
          Handling reasonably needed to inspect an item is allowed where required
          by applicable law. Any value deduction will be evidence-based and lawful.
        </p>
      </PolicySection>

      <PolicySection title="3. Exclusions">
        <p>Change-of-mind returns are not accepted for:</p>
        <ul>
          <li>pierced earrings or other sealed hygiene-sensitive goods once the seal is removed;</li>
          <li>personalised, engraved, resized, or made-to-order products;</li>
          <li>gift cards, digital products, or store credit once issued or used; and</li>
          <li>items clearly marked final sale before purchase, where that restriction is lawful.</li>
        </ul>
        <p>
          An exclusion never removes rights relating to a defect, safety issue,
          misdescription, or our error.
        </p>
      </PolicySection>

      <PolicySection title="4. How to request and send a return">
        <ol>
          <li>Email <a href="mailto:gear@mefurvexo.monster">gear@mefurvexo.monster</a> with the order number, item, and reason.</li>
          <li>Wait for eligibility confirmation and the correct return address.</li>
          <li>Pack the item securely; do not place labels directly on product packaging.</li>
          <li>Use a trackable service and keep the receipt until the return is completed.</li>
        </ol>
        <p>
          Do not send a return to the address printed on a parcel unless our return
          instructions confirm it.
        </p>
      </PolicySection>

      <PolicySection title="5. Return shipping">
        <p>
          For an accepted change-of-mind return, return shipping is normally paid by
          the customer. If the item is faulty, damaged in transit, incorrectly
          supplied, or otherwise our responsibility, we will provide a return method
          or reimburse reasonable return cost where required. Customs forms should
          identify the parcel as returned merchandise where accurate.
        </p>
      </PolicySection>

      <PolicySection title="6. Inspection and refunds">
        <p>
          We inspect the returned item and notify you of the outcome. An approved
          refund is sent to the original payment method. Bank or provider posting
          times are outside our control. Original standard delivery charges are
          refunded only where required by law or where the return results from our
          error. Import duties paid to a government may need to be reclaimed from
          that authority.
        </p>
      </PolicySection>

      <PolicySection title="7. Exchanges">
        <p>
          An exchange depends on stock availability. We may instead refund the
          returned item and invite a new order, particularly where prices, currency,
          or cross-border delivery costs differ. A replacement for a fault is
          handled under the <Link to="/warranty">Warranty &amp; Faulty Goods Policy</Link>.
        </p>
      </PolicySection>

      <PolicySection title="8. Promotions, gifts, and bundles">
        <p>
          Refunds reflect the amount actually paid after discount. Where returning
          part of a bundle means an offer no longer qualifies, the lawful refund may
          be recalculated using the disclosed offer terms. A promotional gift must
          be returned unused with the qualifying order unless the offer states it
          may be kept or law requires otherwise.
        </p>
      </PolicySection>

      <PolicySection title="9. Faulty or incorrect goods">
        <p>
          Contact us promptly with the order number, a description, and photographs
          where helpful. Do not continue using an item that may be unsafe. Remedies
          can include repair, replacement, price reduction, or refund depending on
          the issue and applicable law. See the{" "}
          <Link to="/warranty">Warranty &amp; Faulty Goods Policy</Link> for details.
        </p>
      </PolicySection>
    </PolicyLayout>
  );
}

export default Returns;
